<template>
  <v-form v-model="valid" ref="mainForm">
    <CartesInfosRepondants :societe="sas.societe" class="mb-4" />
    <CatalogueLive
      code="repondant_ouinon"
      :live="liveSasSociete(25939)"
      v-model="sasSociete.declarerLaModificationDeRepondant"
    />
    <CatalogueLive
      code="actionnaire_repondant"
      :items="listeRepondant"
      v-model="sas.sasSociete.repondant"
      :live="{ endpoint: 'sas-societe', cle: 25924, fileId: sas.sasSociete.id }"
      :opqIf="conditionRepondant"
    />
    <CatalogueLive
      code="actionnaire_substitut"
      :items="listeRepondantSubstitut"
      v-model="sas.sasSociete.repondantSubstitut"
      :live="{ endpoint: 'sas-societe', cle: 25925, fileId: sas.sasSociete.id }"
      :opqIf="
        conditionRepondant &&
        sas.sasSociete.repondant &&
        listeRepondantSubstitut.length >= 1
      "
    />
    <DatePickerLive
      code="repondant_date"
      v-model="sasSociete.dateChangementRepondant"
      :live="{ endpoint: 'sas-societe', cle: 25940, fileId: sas.sasSociete.id }"
      :opqIf="conditionRepondant"
      :minValue="serverDate()"
    />
    <v-checkbox
      v-if="conditionRepondant"
      class="list_counter_validator my-2 ml-6 p-0"
      :input-value="conditionDateNouveauActionnaire"
      :rules="[
        () =>
          conditionDateNouveauActionnaire ||
          getRessource('condition_date_nouvel_actionnaire'),
      ]"
    ></v-checkbox>

    <v-checkbox
      v-if="conditionRepondant"
      class="list_counter_validator my-2 ml-6 p-0"
      :input-value="conditionDateDissociationActionnaire"
      :rules="[
        () =>
          conditionDateDissociationActionnaire ||
          getRessource('condition_date_dissociation_actionnaire'),
      ]"
    ></v-checkbox>
    <validate
      :that="
        !unRepondantActuelDissocie ||
        (unRepondantActuelDissocie && conditionRepondant)
      "
      else="condition_dissociation_repondants"
    />
  </v-form>
</template>

<script>
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import DatesHelpers from "@/components/ui/mixins/DatesHelpers"
import RessourcesHelpers from "@/components/ui/mixins/RessourcesHelpers"
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CartesInfosRepondants from "@/components/form_parts/CarteInfosRepondants.vue"
import Validate from "@/components/ui/common/Validate.vue"
export default {
  mixins: [
    CataloguesHelpers,
    DatesHelpers,
    StepFormWithValidation,
    RessourcesHelpers,
  ],
  props: {
    sas: { type: Object },
  },
  components: {
    CartesInfosRepondants,
    Validate,
  },
  computed: {
    sasSociete() {
      return this.sas.sasSociete
    },
    listeRepondant() {
      return this.sas.retraitActionnaires
        ?.filter(
          (r) =>
            r.actionnaire &&
            r.dissociation !== true &&
            r.actionnaire.id !== this.sasSociete.repondantSubstitut
        )
        .concat(
          this.sas.actionnaires?.filter(
            (a) =>
              a.actionnaire &&
              a.actionnaire.id !== this.sasSociete.repondantSubstitut
          )
        )
        .map(this.getTextSasActionnaireDropdown)
    },
    listeRepondantSubstitut() {
      return this.sas.retraitActionnaires
        ?.filter(
          (r) =>
            r.actionnaire &&
            r.dissociation !== true &&
            r.actionnaire.id !== this.sasSociete.repondant
        )
        .concat(
          this.sas.actionnaires?.filter(
            (a) =>
              a.actionnaire && a.actionnaire.id !== this.sasSociete.repondant
          )
        )
        .map(this.getTextSasActionnaireDropdown)
    },
    conditionRepondant() {
      return this.estOui(this.sas.sasSociete.declarerLaModificationDeRepondant)
    },
    conditionDateNouveauActionnaire() {
      const repondantEstNouveau =
        this.sas.actionnaires.findIndex(
          (x) => x.actionnaire && x.actionnaire.id === this.sasSociete.repondant
        ) > -1
      const repondantSubstitutEstNouveau =
        this.sas.actionnaires.findIndex(
          (x) =>
            x.actionnaire &&
            x.actionnaire.id === this.sasSociete.repondantSubstitut
        ) > -1
      if (repondantEstNouveau || repondantSubstitutEstNouveau) {
        return (
          this.sasSociete.dateChangementRepondant >=
          this.sasSociete.dateAjoutDActionnaires
        )
      } else {
        return true
      }
    },
    repondantActuelEstDissocie() {
      return (
        this.sas.retraitActionnaires.findIndex(
          (x) =>
            x.dissociation &&
            x.actionnaire &&
            x.actionnaire.id === this.sas.societe.repondantId
        ) > -1
      )
    },
    repondantSubstitutActuelEstDissocie() {
      return (
        this.sas.retraitActionnaires.findIndex(
          (x) =>
            x.dissociation &&
            x.actionnaire &&
            x.actionnaire.id === this.sas.societe.repondantSubstitutId
        ) > -1
      )
    },
    unRepondantActuelDissocie() {
      return (
        this.repondantActuelEstDissocie ||
        this.repondantSubstitutActuelEstDissocie
      )
    },
    conditionDateDissociationActionnaire() {
      if (this.unRepondantActuelDissocie) {
        return (
          this.sasSociete.dateChangementRepondant <=
            this.sasSociete.dateDissociationDActionnaires ||
          (this.sasSociete.dateChangementRepondant == this.serverDate() &&
            this.sasSociete.dateDissociationDActionnaires < this.serverDate())
        )
      } else {
        return true
      }
    },
  },
  methods: {
    getTextSasActionnaireDropdown(sasActionnaire) {
      const value = sasActionnaire.actionnaire.id
      let text =
        sasActionnaire.actionnaire.fullName +
          " " +
          sasActionnaire.actionnaire.licenseNumber ||
        "Veuillez sélectionner un actionnaire"
      return { value, text }
    },
    liveSasSociete(cle) {
      return { endpoint: "sas-societe", cle: cle, fileId: this.sasSociete.id }
    },
  },
}
</script>

<style></style>
